import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import NewsListItem from "./news-list-item.jsx";

export default class NewsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sortBy: 'creationDate',
            sortDirection: 'asc'
        }

        this.onTableHeaderClick = this.onTableHeaderClick.bind(this);
    }

    onTableHeaderClick(event) {
        var id = event.target.id;
        var direction = 'asc';

        if (this.state.sortBy == id) {
            if (this.state.sortDirection == 'asc') {
                direction = 'desc';
            }
            else {
                direction = 'asc';
            }
        }

        this.setState({
            sortBy: id,
            sortDirection: direction
        });

        function compare(value1, value2) {
            if (value1 < value2)
                return -1;
            if (value1 > value2)
                return 1;
            return 0;
        }

        if (direction == 'asc') {
            switch (id) {
                case 'id': 
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.id, obj2.id);
                    });
                    break;
                case 'title':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.title, obj2.title);
                    });
                    break;
                case 'subTitle':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.subTitle, obj2.subTitle);
                    });
                    break;
                case 'date':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.publishedDate, obj2.publishedDate);
                    });
                    break;
                case 'content':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.contentShort, obj2.contentShort);
                    });
                    break;
                case 'sticky':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.sticky, obj2.sticky);
                    });
                    break;
                case 'createdDate':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.creationDate, obj2.creationDate);
                    });
                    break;
                case 'createdBy':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.creationOperator, obj2.creationOperator);
                    });
                    break;
                case 'modifiedDate':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.modifyDate, obj2.modifyDate);
                    });
                    break;
                case 'modifiedBy':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj1.modifyOperator, obj2.modifyOperator);
                    });
                    break;
            }
        }
        else {
            switch (id) {
                case 'id': 
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.id, obj1.id);
                    });
                    break;
                case 'title':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.title, obj1.title);
                    });
                    break;
                case 'subTitle':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.subTitle, obj1.subTitle);
                    });
                    break;
                case 'date':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.publishedDate, obj1.publishedDate);
                    });
                    break;
                case 'content':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.contentShort, obj1.contentShort);
                    });
                    break;
                case 'sticky':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.sticky, obj1.sticky);
                    });
                    break;
                case 'createdDate':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.creationDate, obj1.creationDate);
                    });
                    break;
                case 'createdBy':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.creationOperator, obj1.creationOperator);
                    });
                    break;
                case 'modifiedDate':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.modifyDate, obj1.modifyDate);
                    });
                    break;
                case 'modifiedBy':
                    this.props.newsList.sort(function(obj1, obj2) { 
                        return compare(obj2.modifyOperator, obj1.modifyOperator);
                    });
                    break;
            }
        }

        if (this.props.onChange) {
            this.props.onChange(this.props.newsList);
        }
    }

    render() {
        var items = [];

        if (this.props.newsList.length > 0) {
            for (var i = 0; i < this.props.newsList.length; i++) {
                let dataItem = this.props.newsList[i];
                items.push(
                    <NewsListItem vm={dataItem} noLabel={this.props.noLabel} yesLabel={this.props.yesLabel}></NewsListItem>
                );
            }
        }

        return (
            <div className={this.props.newsList.length > 0 ? "" : "ap-hidden"}>
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <td onClick={this.onTableHeaderClick} id="id">ID</td>
                                    <td onClick={this.onTableHeaderClick} id="title">Title</td>
                                    <td onClick={this.onTableHeaderClick} id="subTitle">Subtitle</td>
                                    <td onClick={this.onTableHeaderClick} id="date">Date</td>
                                    <td onClick={this.onTableHeaderClick} id="content">Content</td>
                                    <td onClick={this.onTableHeaderClick} id="sticky">Sticky</td>
                                    <td onClick={this.onTableHeaderClick} id="createdDate">Created Date</td>
                                    <td onClick={this.onTableHeaderClick} id="createdBy">Created By</td>
                                    <td onClick={this.onTableHeaderClick} id="modifiedDate">Modified Date</td>
                                    <td onClick={this.onTableHeaderClick} id="modifiedBy">Modified By</td>
                                </tr>
                            </thead>
                            <tbody>
                                {items}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}